import { render, staticRenderFns } from "./datos-becario.vue?vue&type=template&id=0042de8d&scoped=true&"
import script from "./datos-becario.component.ts?vue&type=script&lang=ts&"
export * from "./datos-becario.component.ts?vue&type=script&lang=ts&"
import style0 from "./datos-becario.vue?vue&type=style&index=0&id=0042de8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042de8d",
  null
  
)

export default component.exports